'use strict';

const transformValueAsArray = (el) => {
    let result = [];
    try {
        result = el.css('transform').match(/[0-9., -]+/)[0].split(',');
    } catch (e) {
        //do nothing
    }
    return result;
};

module.exports = transformValueAsArray;
